import { AppImages, useAppI18N } from '@/app'
import { AuthModal } from './auth/AuthModal'
import { AuthForms } from '../Auth'
import { useAppSelector } from '@/redux'

export const AuthWall = ({ title, ...props }: any) => {
  const registrationWallVariant = useAppSelector(s => s.Session.registrationWallVariant)
  const variant = registrationWallVariant?.split('-')[1] || 'title'
  const { t } = useAppI18N()

  return (
    <AuthModal image={AppImages.AuthWall} name='authWall' imageHeight={211}>
      <AuthForms.SignupForm title={t(`registrationWall.${variant}` as any)} modalName='authWall' />
    </AuthModal>
  )
}
